import {FC} from 'react';

// import Image from 'next/image';
// import {StaticImageData} from 'next/image';
// import {useRouter} from 'next/router';
import {t} from 'i18next';

import emptyBasketImage from 'assets/images/empty-basket.png';
import newEmptyBasketImage from 'assets/images/new-empty-basket.png';
import {Button} from 'components/button/Button';

import {
  StyledBasketBodyEmptyWrapper,
  StyledDescription,
  StyledEmptyContainer,
  StyledEmptyContent,
  StyledEmptyImage,
  StyledTitle
} from './styles';

export type BasketEmptyBodyViewProps = {
  mediaURL: string;
  title: string;
  description: string;
  onAction: () => void;
  buttonLabel: string;
  loading: boolean;
  isFlexibleBasketEnabled: boolean;
};
export const BasketEmptyBodyView: FC<BasketEmptyBodyViewProps> = ({
  mediaURL,
  title,
  description,
  onAction,
  buttonLabel,
  loading,
  isFlexibleBasketEnabled
}) => {
  return (
    <StyledBasketBodyEmptyWrapper isFlexibleBasketEnabled={isFlexibleBasketEnabled}>
      <StyledEmptyContainer isFlexibleBasketEnabled={isFlexibleBasketEnabled}>
        <StyledEmptyImage>
          <img src={mediaURL} alt="Empty" width={200} height={200} />
        </StyledEmptyImage>
        <StyledEmptyContent>
          <StyledTitle component={'h4'} variant={'h4'}>
            {title}
          </StyledTitle>
          <StyledDescription component={'p'} variant="body2">
            {description}
          </StyledDescription>
          <Button color="primary" shape="rounded" variant="contained" onClick={onAction} loading={loading}>
            {buttonLabel}
          </Button>
        </StyledEmptyContent>
      </StyledEmptyContainer>
    </StyledBasketBodyEmptyWrapper>
  );
};

export interface BasketDrawerEmptyBodyProps {
  onClick: () => void;
  isFlexibleBasketEnabled: boolean;
}

export const BasketEmptyBody: FC<BasketDrawerEmptyBodyProps> = (props) => {
  // const router = useRouter();
  // const {loading} = useBasket();

  return (
    <BasketEmptyBodyView
      title={props.isFlexibleBasketEnabled ? t('message.noProducts') : t('message.noItems')}
      description={t('message.letsChange')}
      loading={false}
      onAction={() => {
        props.onClick();
      }}
      mediaURL={props.isFlexibleBasketEnabled ? newEmptyBasketImage : emptyBasketImage}
      buttonLabel={t('button.ctaBrowseCategory')}
      isFlexibleBasketEnabled={props.isFlexibleBasketEnabled}
    />
  );
};

BasketEmptyBody.displayName = 'BasketDrawerEmptyBody';
BasketEmptyBodyView.displayName = 'BasketDrawerEmptyBodyView';

export default BasketEmptyBody;
